export function fmtSize(n: number | string | null | undefined): string {
  if (n == null) return '';
  const num = Number(n);
  if (!isFinite(num)) return String(n);
  if (num >= 1000) return Math.round(num).toString();
  return num % 1 === 0 ? String(num) : num.toFixed(2);
}

export function balanceToShares(raw: string | number | bigint | null | undefined): number {
  try {
    const v = BigInt(String(raw || '0'));
    const whole = v / 1000000n;
    const n = Number(whole);
    return isFinite(n) && n >= 0 ? n : 0;
  } catch {
    const n = Number(raw || '0') / 1e6;
    return isFinite(n) && n >= 0 ? Math.floor(n) : 0;
  }
}


